import styled from "styled-components";

export const Pesquisou = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    font-size: 25px;
  }
  p {
    margin-left: 5px;
    margin-top: 10px;
  }

  font-size: 25px;
`;

export const AfterPesquisou = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h2 {
      font-family: "Mulish", sans-serif;
      font-size: 20px;
      margin-bottom: 20px;
      font-weight: bold;
    }
  }
`;
